import styled from "styled-components";

import { Button, FlexDiv } from "@/components/Atoms";
import theme from "@/foundation/Theme";

export const Wrapper = styled(FlexDiv)`
  background: url(${({ banner }) => banner}) center no-repeat;
  background-size: cover;
  position: relative;
  padding: ${({ heroPadding }) => heroPadding || "90px 0"};
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: ${theme.colors.linearGradBlue};
  }
  @media only screen and (max-width: 767px) {
    padding: 50px 0;
    background-position: 70% 0px;
  }
`;

export const WrapperDiv = styled(FlexDiv)`
  flex-direction: column;
  max-width: ${({ contentWidth }) => contentWidth || "540px"};
  @media only screen and (max-width: 767px) {
    max-width: 100%;
    text-align: center;
  }
`;

export const StyledButton = styled(Button)`
  max-width: 330px;
  cursor: default !important;
  @media only screen and (max-width: 767px) {
    margin: 15px auto 0;
    font-size: 15px;
  }
`;

export const BrandImage = styled.img`
  position: absolute;
  right: 20px;
  bottom: ${({ bottom }) => bottom || "10px"};
  object-fit: contain;
  width: ${({ width }) => width || "200px"};

  @media only screen and (max-width: 600px) {
    right: 0px;
    bottom: 5px;
    width: 80px;
  }

  @media only screen and (min-width: 600px) and (max-width: 767px) {
    right: 10px;
    bottom: 5px;

    width: 100px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    right: 10px;
    bottom: 5px;

    width: 120px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    right: 10px;
    bottom: 5px;

    width: 140px;
  }
`;
